import merge from 'lodash/merge';
import { Configuration, CartV1Api } from '@invitae/stargate-ts-fetch';

var getClients = function (options) {
    var _a;
    if (options === void 0) { options = {}; }
    // base URL for requests
    var basePath = process.env.REACT_APP_CART_SVC_HOST;
    // remove the /cart/ suffix from process.env.REACT_APP_CART_SVC_HOST as the CartV1Api already contains the /cart/v1 prefix.
    // Without this logic, we end up with duplicated /cart/cart/v1 in the URL (https://invitae.dev.locusdev.net/apigw/cart/cart/v1/cart)
    // Some apps pass the basePath via Context, others via env variable, so we need to handle both cases to avoid having conditional logic
    // in client apps
    if (options.basePath)
        options.basePath = (_a = options === null || options === void 0 ? void 0 : options.basePath) === null || _a === void 0 ? void 0 : _a.replace(/\/cart$/, '');
    if (process.env.REACT_APP_CART_SVC_HOST)
        basePath = process.env.REACT_APP_CART_SVC_HOST.replace(/\/cart$/, '');
    var baseConfiguration = {
        basePath: basePath,
        credentials: 'include',
    };
    var mergedOptions = merge(baseConfiguration, options);
    var configuration = new Configuration(mergedOptions);
    return {
        cartApiClient: new CartV1Api(configuration),
        partnershipApiClient: new CartV1Api(configuration),
        reflexApiClient: new CartV1Api(configuration),
        rereqApiClient: new CartV1Api(configuration),
    };
};

export { getClients };
//# sourceMappingURL=index.esm.js.map
